import React from "react"
import OrbitLoading from "@kiwicom/orbit-components/lib/Loading"
import { FormattedMessage } from "react-intl"

const Loading = ({ dataTest }: { dataTest?: string }) => (
  <OrbitLoading
    type="pageLoader"
    text={<FormattedMessage id="common.loading" defaultMessage="Loading" />}
    dataTest={dataTest}
  />
)

export default Loading
